import { jsx as _jsx } from "react/jsx-runtime";
import { SmartTable } from '../../table';
export const SampleDataContainer = ({ tableProps }) => {
    return _jsx(SmartTable, { ...tableProps });
};
//# sourceMappingURL=SampleDataContainer.js.map